import React from "../../__snowpack__/pkg/react.js";
import id from "../assets/images/flags/id.svg";
import ph from "../assets/images/flags/ph.svg";
import th from "../assets/images/flags/th.svg";
import cn from "../assets/images/flags/cn.svg";
import my from "../assets/images/flags/my.svg";
import vn from "../assets/images/flags/vn.svg";
import sg from "../assets/images/flags/sg.svg";
import de from "../assets/images/flags/de.svg";
import be from "../assets/images/flags/be.svg";
import it from "../assets/images/flags/it.svg";
import pl from "../assets/images/flags/pl.svg";
import hk from "../assets/images/flags/hk.svg";
import tw from "../assets/images/flags/tw.svg";
import br from "../assets/images/flags/br.svg";
export default function FlagIcon(props) {
  const {countryCode, ...imgProps} = props;
  const src = {
    id,
    ph,
    th,
    cn,
    my,
    vn,
    sg,
    de,
    be,
    it,
    pl,
    hk,
    tw,
    br
  }[String(countryCode).toLowerCase()];
  if (!src) {
    return null;
  }
  return /* @__PURE__ */ React.createElement("img", {
    src,
    ...imgProps,
    style: {
      display: "inline-block",
      width: 16,
      height: 12,
      boxShadow: "0 0 4px #ddd",
      ...imgProps.style
    }
  });
}
